import React from "react";
import "./ThanksQuestionStyle.scss";
import "./ThanksQuestionStyle.scss";
import { useLocation, useNavigate } from "react-router-dom";

function ThanksQuestion() {
  const navigate = useNavigate();
  const handleSubmit = () => {
    navigate("/");
  };

  const location = useLocation();
  const { planDetails } = location.state || {};
  return (
    <>
      <div className="success-card">
        <div className="success-icon">
          <i className="bi bi-check-circle"></i>
        </div>

        <h5 className="plan-name">
          Thank you for contacting <br />
          <span>Dhofar Insurance Company</span>
        </h5>
        <h2 className="title py-3">Your premium payment is successful.</h2>

        <div className="col-md-12 my-3 d-flex justify-content-center">
          <label className="plan-name">Thank you!</label>
        </div>

        {/* <p className="plan-desc mt-3">
            We have received your request for
            <br />
            <span className="request-id">{requestId}</span>
          </p> */}

        <p className="plan-desc">
          Please call us @ <strong>8000 7777</strong> for further assistance.
        </p>
        <div className="row mt-5">
          <button
            type="button"
            onClick={handleSubmit}
            className="btn  flex-fill rounded-4 p-3 fw-bold mx-2 my-2 mb-4"
          >
            Go back home
          </button>
        </div>
      </div>
    </>
  );
}

export default ThanksQuestion;
